import { Provider } from "react-redux";
import { persistor, store } from "@redux/store";
import { PersistGate } from "redux-persist/integration/react";
import GlobalStyles from "./GlobalStyles";
import theme from "./theme";
import Router from "@router/Router";
import { routes } from "@router/config";
import { ThemeProvider } from "styled-components";
import { useEffect } from "react";
import ContactUs from "@components/organisms/ContactUs";
import 'react-spring-bottom-sheet/dist/style.css'


const App = () => {
  useEffect(() => {
    localStorage.clear();
  })
  return (
    <Provider store={store}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <PersistGate loading={null} persistor={persistor}>
            <Router routes={routes} />
            <ContactUs  />
        </PersistGate>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
